import { Box } from '@mui/material';

interface ColorSwatchProps {
    /** Any CSS background: a colour, or a gradient that pictures a ramp or a pair. */
    readonly background: string;
    readonly width: number;
    readonly height: number;
    /** Lets the swatch take a slot's class, such as a Chip's icon. */
    readonly className?: string;
}

/**
 * A small block of colour that stands for a palette choice beside its
 * name. Decorative: the name carries the meaning, so the swatch is hidden
 * from assistive technology.
 */
export default function ColorSwatch({
    background,
    width,
    height,
    className,
}: ColorSwatchProps) {
    return (
        <Box
            aria-hidden
            className={className}
            sx={{ width, height, borderRadius: 0.5, flexShrink: 0, background }}
        />
    );
}
